"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApolloQuery = void 0;
var client_1 = require("@apollo/client");
var react_1 = require("react");
function useApolloQuery(queryFn, options) {
    if (options === void 0) { options = {}; }
    // Without this, loading does not update when refetching after data.
    var optionsWithDefaults = __assign({ notifyOnNetworkStatusChange: true }, options);
    // Need to track, because apollo-client doesn't set an error when
    // we're in the loading state. This allows us to get the error-fetching state.
    var isErrorRef = (0, react_1.useRef)(false);
    var _a = (0, client_1.useQuery)(queryFn, optionsWithDefaults), loading = _a.loading, error = _a.error, data = _a.data, refetch = _a.refetch;
    if (data) {
        isErrorRef.current = false;
        return {
            status: 'data',
            isFetching: loading,
            refetch: refetch,
            // @ts-ignore Must exist
            data: data,
        };
    }
    if (typeof error !== 'undefined' || isErrorRef.current) {
        isErrorRef.current = true;
        return {
            status: 'error',
            isFetching: loading,
            refetch: refetch,
            // @ts-ignore Must exist
            error: error,
        };
    }
    return {
        status: 'no-data',
        isFetching: loading,
    };
}
exports.useApolloQuery = useApolloQuery;
